import styled from 'styled-components';
import { colors } from 'vars';

interface StyledModalWrapperProps {
  $isOpen: boolean;
}

export const StyledModalWrapper = styled.div<StyledModalWrapperProps>`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  background-color: ${colors.semanticTextDisabled};
`;

export const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  gap: 8px;
  min-width: 600px;
  max-width: 90%;
  background-color: ${colors.white};
`;

export const StyledModalHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;

  p {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
  }

  i.icon {
    color: #cbcbca;

    &:hover {
      color: ${colors.grey01500};
      cursor: pointer;
    }
  }
`;

export const StyledModalContentContainer = styled.div`
  padding: 32px 28px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: ${colors.neutralRowsBG};
`;

export const StyledModalFooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 23px 28px;
  gap: 12px;
`;
